import { Component, input, output } from '@angular/core';

@Component({
  selector: 'pp-radio-button',
  templateUrl: './radio-button.component.html',
})
export class RadioButtonComponent {

  readonly checked = input<boolean>();
  readonly id = input<string>();
  readonly label = input<string>();
  readonly name = input<string>();
  readonly text = input<string>();
  readonly value = input<any>();

  readonly optionChanged = output<any>();
}
